export async function signWalletProof(provider, address, message) {
  if (!provider?.request) throw new Error('Open this page in a browser with your Ethereum wallet installed, then try again.');
  const accounts = await provider.request({ method: 'eth_requestAccounts' });
  const account = accounts.find(value => value.toLowerCase() === address.toLowerCase());
  if (!account) throw new Error('Select the NFT wallet address in your wallet app, then try again.');
  const hex = `0x${Array.from(new TextEncoder().encode(message)).map(value => value.toString(16).padStart(2, '0')).join('')}`;
  return provider.request({ method: 'personal_sign', params: [hex, account] });
}
